'use strict';

var StepButtonsController = ngtk.controller.Base.extend({

    $inject: ['$scope', 'bbw.LayoutTypeSvc', '$timeout'],

    $onInit: function() {
        this.stepsRange = ngtk.tools.array.range(1, +this.steps).map(function(step) {
            return {
                step: step,
                isNext: step > this.step
            }
        }.bind(this));
        this.allowBack = this.step > 1;
        this.showBack = this.allowBack;
        this.allowBack && bbw.onMobileBack(this.$scope, this.back.bind(this));
    },

    back: function() {
        if (this.allowBack && angular.isFunction(this.onBack)) {
            this.onBack();
        }
        return false;
    },

    next: function() {
        if (angular.isFunction(this.onNext)) {
            this.onNext();
        }
        return false;
    }

});

bbw.StepButtonsComponent = {
    templateUrl: bbw.templateUrl('components/step-buttons.component.html'),
    controller: StepButtonsController,
    bindings: {
        step: '<',
        steps: '<',
        addClass: '<',
        backLabel: '<',
        nextLabel: '<',
        nextDisabled: '<',
        nextSubmit: '<',
        onBack: '&',
        onNext: '&'
    }
};
